function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import CampaignResult from '../components/campaign_result/index';
import Startup from './Startup';
function SharedCampaignResultLoader(_param) {
    var results = _param.results, campaign = _param.campaign, campaignResultIdentifier = _param.campaignResultIdentifier, props = _object_without_properties(_param, [
        "results",
        "campaign",
        "campaignResultIdentifier"
    ]);
    return /*#__PURE__*/ React.createElement(Startup, props, /*#__PURE__*/ React.createElement(Switch, null, /*#__PURE__*/ React.createElement(Route, {
        path: "*/results/:identifier",
        render: function(props) {
            return /*#__PURE__*/ React.createElement(CampaignResult, _object_spread({
                campaign: campaign,
                results: results,
                campaignResultIdentifier: campaignResultIdentifier
            }, props));
        }
    })));
}
export default SharedCampaignResultLoader;
